// main-search-page-filter.js
console.log('✅ main-search-page-filter.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, setAppStateValueByKey, setNestedAppStateValueByKey } from '../../js/state.js';
import { getTextTranslationByKey, loadTextTranslations } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { isNodeEnvironment } from '../../js/utils-fetch-data-json.js';
import { debounceShared } from '../../js/utils-debounce.js';

import { LRUCacheWithTTL } from '../../js/utils-cache.js';

import { searchPageComponentSharedState } from '../main-search-page-component/main-search-page-component-shared-state.js';
import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';
import { populateSearchRequestModelFromSelectedFilters } from './main-search-page-component.js';

let sectionData = {
  categories: [],
  subcategories: [],
  products: [],
  supplierTypes: [],
  sellerLevels: [],
  buyTypes: [],
  unitOfMeasures: [],
  customisationTypes: [],
  allRealSpecsAndSpecOptions: [],
  countryOfOrigins: [],
  countryOfSellers: [],
  shippedFromCountries: [],
};

let _tempTextTranslator = null;

export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

const lang = appState.SiteLanguageCookie;

let limitBeforeShowingMore = 3;
let limitBeforeShowingMoreCategory = 2;
let limitBeforeShowingMoreSubcategory = 4;
let limitBeforeShowingMoreProduct = 4;

let limitBeforeShowingMoreUnitOfMeasure = 3;
let limitBeforeShowingMoreSpecAndOptions = 3;

let limitBeforeShowingMoreShippedFromCountry = 3;
let limitBeforeShowingMoreCountryOfOrigin = 3;
let limitBeforeShowingMoreCountryOfSeller = 3;

export async function buildComponentMainSearchPageFilter(layoutType = 'allProducts') {
  try {
    await initTempTextTranslator(lang);

    // const tempTranslator = await loadTextTranslations(lang);

    // Destructure just the keys you need, giving them your desired local names
    const {
      keyFilterBy: lblFilterBy,
      keyClearAll: lblClearAll,
      keyCategory: lblCategory,
      keySubcategory: lblSubcategory,
      keyProduct: lblProduct,
      keySupplierType: lblSupplierType,
      keySellerLevel: lblSellerLevel,
      keyBuyType: lblBuyType,
      keyShowMore: lblShowMore,
      keyShowLess: lblShowLess,
      keyClear: lblClear,
      keyAppliedFilter: lblAppliedFilter,
      keyAppliedFilters: lblAppliedFilters,
      keySeeResults: lblSeeResults,
      keyPrice: lblPrice,
      keyMinimumOrderQty: lblMinimumOrderQty,
      keyUnitMeasurement: lblUnitMeasurement,
      keyCustomisation: lblCustomisation,
      keyCountryOfOrigin: lblCountryOfOrigin,
      keyCountryOfSeller: lblCountryOfSeller,
      keyShippedFromCountry: lblShippedFromCountry,
    } = _tempTextTranslator;

    //const labels = await Promise.all([
    //    getTextTranslationByKey("keyFilterBy", lang),
    //    getTextTranslationByKey("keyClearAll", lang),
    //    getTextTranslationByKey("keyCategory", lang),
    //    getTextTranslationByKey("keySubcategory", lang),
    //    getTextTranslationByKey("keyProduct", lang),
    //    getTextTranslationByKey("keySupplierType", lang),
    //    getTextTranslationByKey("keySellerLevel", lang),
    //    getTextTranslationByKey("keyBuyType", lang),
    //    getTextTranslationByKey("keyShowMore", lang),
    //    getTextTranslationByKey("keyShowLess", lang),
    //    getTextTranslationByKey("keyClear", lang),
    //    getTextTranslationByKey("keyAppliedFilter", lang),
    //    getTextTranslationByKey("keyAppliedFilters", lang),
    //    getTextTranslationByKey("keySeeResults", lang),

    //]);

    //const [lblFilterBy, lblClearAll, lblCategory, lblSubcategory, lblProduct, lblSupplierType, lblSellerLevel, lblBuyType, lblShowMore, lblShowLess, lblClear, lblAppliedFilter, lblAppliedFilters, lblSeeResults] = labels;

    let showTotalClearAllFilters = false;

    if (
      !Array.isArray(searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters) ||
      searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.length === 0
    ) {
      showTotalClearAllFilters = false;
    } else {
      showTotalClearAllFilters = true;
    }

    const sidebarHTML = `
         <div class="search-filter-debounce-loader-class-wrapper">
         <div class="search-filter-debounce-loader-class"></div>
         </div>
        <div class="SideBarSearchFilters-wrapper-container">
         

            <div class="SideBarSearchFilters-wrapper">
                <div class="SideBarSearchFilters-header">
                    <button class="grid-filter-sort-search-mobile-btn-show js-hide-filter-btn" >
                        <img src="${
                          APP_CONFIG.IMAGES_BASE_URL
                        }imgs/icons/svg/remove1.svg" width="25" height="25">
                    </button>
                    <div class="basicTable" style="width: 100%;">
                        <div class="basicTableRow">
                            <div class="basicTableCell">${lblFilterBy}</div>
                            <div class="basicTableCell SideBarSearchFilters-header-ClearAll-LinkCell">

                           
                         <button id="btnClearAllFilters"  class="SideBarSearchFilters-header-ClearAll-Link"  ${
                           !showTotalClearAllFilters ? 'style="visibility:hidden;"' : ''
                         }>  ${lblClearAll}</button>


                             

                               
                            </div>
                        </div>
                    </div>
                </div>


                  <div id="divAllAppliedFilters-content-holder">           
                ${buildAllAppliedFiltersSection(
                  lblShowMore,
                  lblShowLess,
                  lblAppliedFilter,
                  lblAppliedFilters
                )}
                </div>
                  <div id="divOtherAppliedFilters-content-holder">     
                ${buildFilterSection(
                  lblCategory,
                  lblShowMore,
                  lblShowLess,
                  lblClear,
                  sectionData.categories,
                  'Categories',
                  'Category',
                  'DeptID'
                )}
                ${buildFilterSection(
                  lblSubcategory,
                  lblShowMore,
                  lblShowLess,
                  lblClear,
                  sectionData.subcategories,
                  'Subcategories',
                  'Subcategory',
                  'CatID'
                )}
                 ${buildFilterSection(
                   lblProduct,
                   lblShowMore,
                   lblShowLess,
                   lblClear,
                   sectionData.products,
                   'Products',
                   'Product',
                   'ProductID'
                 )}
                ${buildFilterSection(
                  lblSupplierType,
                  lblShowMore,
                  lblShowLess,
                  lblClear,
                  sectionData.supplierTypes,
                  'SupplierTypes',
                  'SupplierType',
                  'SupplierTypeID'
                )}
                ${buildFilterSection(
                  lblSellerLevel,
                  lblShowMore,
                  lblShowLess,
                  lblClear,
                  sectionData.sellerLevels,
                  'SellerLevels',
                  'SellerLevel',
                  'SellerLevelID'
                )}
                ${buildFilterSection(
                  lblBuyType,
                  lblShowMore,
                  lblShowLess,
                  lblClear,
                  sectionData.buyTypes,
                  'BuyTypes',
                  'BuyType',
                  'BuyTypeID'
                )}
                  ${buildPriceFilterSection(lblPrice, lblClear)}
                  ${buildMOQFilterSection(lblMinimumOrderQty, lblClear)}
                  ${buildFilterSection(
                    lblUnitMeasurement,
                    lblShowMore,
                    lblShowLess,
                    lblClear,
                    sectionData.unitOfMeasures,
                    'UnitOfMeasures',
                    'UnitOfMeasure',
                    'UnitOfMeasureID'
                  )}
                  ${buildFilterSection(
                    lblCustomisation,
                    lblShowMore,
                    lblShowLess,
                    lblClear,
                    sectionData.customisationTypes,
                    'CustomisationTypes',
                    'CustomisationType',
                    'CustomisationTypeID'
                  )}
                  ${buildAllRealSpecsAndSpecOptionsFilterSection(
                    lblClear,
                    lblShowMore,
                    lblShowLess,
                    sectionData.allRealSpecsAndSpecOptions
                  )}
                    ${buildFilterSection(
                      lblCountryOfOrigin,
                      lblShowMore,
                      lblShowLess,
                      lblClear,
                      sectionData.countryOfOrigins,
                      'CountryOfOrigins',
                      'CountryOfOrigin',
                      'CountryOfOriginID'
                    )}
                    ${buildFilterSection(
                      lblCountryOfSeller,
                      lblShowMore,
                      lblShowLess,
                      lblClear,
                      sectionData.countryOfSellers,
                      'CountryOfSellers',
                      'CountryOfSeller',
                      'CountryOfSellerID'
                    )}
                    ${buildFilterSection(
                      lblShippedFromCountry,
                      lblShowMore,
                      lblShowLess,
                      lblClear,
                      sectionData.shippedFromCountries,
                      'ShippedFromCountries',
                      'ShippedFromCountry',
                      'ShippedFromCountryID'
                    )}

                  </div>


                <div class="SideBarSearchFilters-bottom-see-results-btn-wrapper">
                    <button id="btnSeeResults" class="SideBarSearchFilters-bottom-see-results-btn js-hide-filter-btn"> ${lblSeeResults}</button>
                </div>
            </div>
        </div>`;

    // registerEventListenerToAttach(async () => attachEventListenersMainSearchPageFilter(lang, searchRequestModel, layoutType, dtActualSearchResultNew));

    return sidebarHTML;
  } catch (err) {
    console.error('❌ Error building MainSearchPageFilter:', err);
    alert('Error building MainSearchPageFilter: ' + err.message);
    return '<div>Error loading filters</div>';
  }
}

function buildFilterSection(
  title,
  lblShowMore,
  lblShowLess,
  lblClear,
  sectionData,
  types,
  type,
  specID
) {
  const isShowingMore = sectionData.ShowMoreOrLess === 'ShowMore';
  const toggleLabel = isShowingMore ? lblShowMore : lblShowLess;

  let shouldShowMoreSection = sectionData.divShowMoreIsVisible;

  let isChecked = false;

  if (appState.SearchFilters[`ckListAll${types}`] === true) {
    isChecked = true;
  }

  let showCurrentSectionClearAllFilters = false;

  //const specID = getSpecIDByType(types);

  //get count of filters in the section
  const countOfFiltersInSection = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.filter(
    x => x.SpecID === specID
  ).length;
  if (countOfFiltersInSection > 0) {
    showCurrentSectionClearAllFilters = true;
  } else {
    showCurrentSectionClearAllFilters = false;
  }

  const showMoreSectionHTML = shouldShowMoreSection
    ? `
        <div id="divShowMore${types}" class="SideBarSearchFilters-showMore-wrapper">
            
            <input type="checkbox" name="checkbox" id="ckListAll${types}" ${
        isChecked ? 'checked' : ''
      } style="display:none;">

            <label for="ckListAll${types}">${toggleLabel}</label>
        </div>
    `
    : '';

  return `
        <div class="SideBarSearchFilters-container">
            <div class="SideBarSearchFilters-container-title-wrapper">
              <label  id="lblSectionTitleIDFor${type}">${title}</label>  <img src="${
    APP_CONFIG.IMAGES_BASE_URL
  }imgs/icons/svg/arrow-toggle-up.svg" width="20" height="20" />
            </div>
            <div>
             <div id="divBtnClearFilterBy${types}"  data-spec-id="${specID}"  data-spec-name="${types}" class="ClearFilterDiv"  ${
    !showCurrentSectionClearAllFilters ? 'style="display:none;"' : ''
  }>

                   <button id="btnClearFilterBy${types}" class="SideBarSearchFilters-header-ClearAll-Link">${lblClear}</button>
            </div>

            <div id="${types}Content">
                ${generateFilterList(sectionData, types, type, specID)}

                 ${showMoreSectionHTML}
            </div>
             </div>
        </div>
       
      `;
}

/**
 * Builds the “Price” filter UI.
 */
function buildPriceFilterSection(lblPrice, lblClear) {
  // read current min/max from shared state (or fall back to empty)
  const min = searchPageComponentSharedState.searchRequestModel.MinPrice || '';
  const max = searchPageComponentSharedState.searchRequestModel.MaxPrice || '';
  // decide whether to show the “clear” button
  const showClear = min !== '' || max !== '';

  return `
    <div class="SideBarSearchFilters-container" id="priceFilterSection">
      <div class="SideBarSearchFilters-container-title-wrapper" id="priceFilterToggle">
        ${lblPrice}
        <img
          id="imgTogglePriceContent"    width="20" height="20"   src="${
            APP_CONFIG.IMAGES_BASE_URL
          }imgs/icons/svg/arrow-toggle-up.svg"   />
      </div>      

      <div id="divSearchFilterPriceContent" >
      <div id="divClearFilterByPrice" class="ClearFilterDivMinMaxPriceOnly" ${
        !showClear ? 'style="display:none;"' : ''
      }>
        <button id="btnClearFilterByPrice" data-spec-id="MinMaxPriceSpecID"  data-spec-name="MinMaxPriceSpecName"  class="SideBarSearchFilters-header-ClearAll-Link"> 
          ${lblClear}
        </button>
      </div>
        <div class="basicTable SideBarSearchFilters-table">
          <div class="basicTableRow SideBarSearchFilters-row">
            <div class="basicTableCell">
              <input type="text" id="txtMinPrice" placeholder="Min" value="${min}" style="width:100px;" />
            </div>
            <div class="basicTableCell">
              <input type="text" id="txtMaxPrice" placeholder="Max" value="${max}" style="width:100px;" />
            </div>
            <div class="basicTableCell">
              <button id="btnApplyPriceFilter">Go</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

function buildMOQFilterSection(lblMinimumOrderQty, lblClear) {
  const minMOQ = searchPageComponentSharedState.searchRequestModel.MinMOQ || '';

  const showClear = minMOQ !== '';

  return `
    <div class="SideBarSearchFilters-container">
      <div class="SideBarSearchFilters-container-title-wrapper">
        <label>${lblMinimumOrderQty}</label>
        <img
          width="20" height="20"
          src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-toggle-down.svg"
          alt=""
        />
      </div>
           
       

      <div id="divSearchFilterMOQContent">
       <div id="divClearFilterByMOQ" class="ClearFilterDivMinMaxMOQOnly" ${
         !showClear ? 'style="display:none;"' : ''
       }>
          <button  id="btnClearFilterByMOQ"  class="SideBarSearchFilters-header-ClearAll-Link" >${lblClear}</button>
        </div>
     

        <div class="basicTable SideBarSearchFilters-table">
          <div class="basicTableRow SideBarSearchFilters-row">
            <div class="basicTableCell">
              <input type="text" id="txtMinMOQ" placeholder="Your order quantity" value="${
                minMOQ > 0 ? minMOQ : ``
              }"    style="width:210px;"  />
            </div>
            <div class="basicTableCell">
              <button id="btnApplyMOQFilter">Go</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

function buildAllRealSpecsAndSpecOptionsFilterSection(
  lblClear,
  lblShowMore,
  lblShowLess,
  parentSectionData
) {
  // alert(`s : ${JSON.stringify(parentSectionData)}`);

  return parentSectionData
    .map(s => {
      // only render if there are items
      const list = s.data.listOfResultsInSection;
      if (Array.isArray(list) && list.length > 0) {
        return buildFilterSection(
          s.title, // use lower-case .title
          lblShowMore,
          lblShowLess,
          lblClear,
          s.data, // { listOfResultsInSection, divShowMoreIsVisible, ShowMoreOrLess }
          s.types,
          s.type,
          s.specID // use lower-case .specID
        );
      }
      return '';
    })
    .join('');
}

function generateFilterList(sectionData, types, type, specID) {
  const list = sectionData?.listOfResultsInSection || [];
  const limit = getLimitByType(types); // We'll define this below
  const showAll = appState.SearchFilters[`ckListAll${types}`] === true;

  return `<div class="basicTable SideBarSearchFilters-table">
        ${list
          .map((item, index) => {
            const isHidden = !showAll && index >= limit ? ' style="display:none;"' : '';
            return `
                <div class="basicTableRow SideBarSearchFilters-row filter-row-${types}" data-index="${index}"${isHidden}>
                    <div class="basicTableCell SideBarSearchFilters-cell-checkbox">
                       <input
                          type="checkbox"
                          id="${types}_${item.SearchResultOptionID}" 
                          data-spec-id="${specID}"
                          data-spec-name="${types}"
                          data-option-id="${item.SearchResultOptionID}"
                          data-option-name="${item.SearchResultOptionName}"
                          data-label-prefix="${type}"
                          ${item.SearchResultOptionIsChecked ? 'checked' : ''}
                        />

                    </div>
                    <div class="basicTableCell SideBarSearchFilters-cell-title">
                        <label for="${types}_${item.SearchResultOptionID}">${
              item.SearchResultOptionName
            }</label>
                    </div>
                    <div class="basicTableCell SideBarSearchFilters-cell-qty">
                      <label for="${types}_${item.SearchResultOptionID}"> (${
              item.SearchResultOptionCount
            })</label>                     
                      
                      </div>
                </div>`;
          })
          .join('')}
    </div>`;
}

async function rebuildAndReplaceAllAppliedFiltersSection(
  lang,
  layoutType,
  handleFiltersChangedSharedWithParent,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  //  alert("Rebuild and replace all applied filters section called!");

  //  alert(JSON.stringify(pageSpecificListOfSpecOptionsSelectedFilters));

  const element = document.getElementById('divAllAppliedFilters-content-holder');
  if (element) {
    const newAppliedFiltersHTML = buildAllAppliedFiltersSection(
      lblShowMore,
      lblShowLess,
      lblAppliedFilter,
      lblAppliedFilters
    );
    element.innerHTML = newAppliedFiltersHTML;

    //show the clear all button if there are filters
    const btnClearAllFilters = document.getElementById('btnClearAllFilters');
    if (btnClearAllFilters) {
      if (searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.length > 0) {
        btnClearAllFilters.style.visibility = 'visible';
      } else {
        btnClearAllFilters.style.visibility = 'hidden';
      }

      // attach the event listener to the clear all button

      await setupListnerForTopAllAppliedClearAllFilters(
        lang,
        layoutType,
        handleFiltersChangedSharedWithParent,
        lblShowMore,
        lblShowLess,
        lblAppliedFilter,
        lblAppliedFilters
      );

      setupToggleForTopAllAppliedFilterSection();

      // Reattach event listeners for the new elements
      setupRemoveAppliedFiltersOnRemoveIconsListeners(
        lang,
        layoutType,
        handleFiltersChangedSharedWithParent,
        lblShowMore,
        lblShowLess,
        lblAppliedFilter,
        lblAppliedFilters
      );

      setupShowMoreToggleTopAllAppliedCheckboxListeners(lblShowMore, lblShowLess);
    }
  }

  await processDebounceAndNotifyParentToRefreshSearchListingsInMainArea(
    lang,
    layoutType,
    handleFiltersChangedSharedWithParent
  );
}

function buildAllAppliedFiltersSection(
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  //alert("Test  aaaaaaa");

  const filters = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters;

  //alert("Test  bbbbbbb");
  //alert(`filters : ${filters}`);

  //if (!filters) {
  //    return "";

  //}

  if (!Array.isArray(filters) || filters.length === 0) return '';

  //alert("Test  cccc");

  const showAll = appState.SearchFilters.ckListAllAppliedFilters === true;
  const toggleLabel = showAll ? lblShowLess || 'Show Less' : lblShowMore || 'Show More';
  const labelTitle =
    filters.length > 1
      ? lblAppliedFilters || 'Applied Filters'
      : lblAppliedFilter || 'Applied Filter';
  const showToggle = filters.length > limitBeforeShowingMore;

  const rowsHtml = filters
    .map((filter, index) => {
      const isHidden = !showAll && index >= limitBeforeShowingMore ? ' style="display:none;"' : '';
      const filterId = `${filter.SpecID}-${filter.OptionID}`;
      return `
            <div class="basicTableRow SideBarSearchFilters-row filter-applied-row"${isHidden}>
                <div class="basicTableCell SideBarSearchFilters-cell-checkbox">
                
                    <svg class="remove-icon filter-remove-icon"
                        data-spec-id="${filter.SpecID}" 
                        data-spec-name="${filter.SpecName}"
                        data-option-id="${filter.OptionID}" 
                        width="20" height="20" viewBox="0 0 24 24" style="cursor:pointer;">
                        <circle cx="12" cy="12" r="12" fill="black" />
                        <line x1="7" y1="7" x2="17" y2="17" stroke="white" stroke-width="2" />
                        <line x1="17" y1="7" x2="7" y2="17" stroke="white" stroke-width="2" />
                    </svg>
                </div>
                <div class="basicTableCell SideBarSearchFilters-cell-title">
                    <label class="SideBarSearchFilters-cell-title-lable filter-remove-icon"
                        data-spec-id="${filter.SpecID}" 
                        data-spec-name="${filter.SpecName}"
                        data-option-id="${filter.OptionID}" 
                        for="imgAllAppliedFiltersContent-${filterId}">
                        ${filter.OptionName}
                    </label>
                </div>
            </div>`;
    })
    .join('');

  const toggleHtml = showToggle
    ? `
        <div id="divRepeaterFiltersAppliedShowMoreDiv" class="SideBarSearchFilters-showMore-wrapper">
            <input type="checkbox" id="ckListAllAppliedFilters" style="display:none;" ${
              showAll ? 'checked' : ''
            }>
            <label for="ckListAllAppliedFilters">${toggleLabel}</label>
        </div>
    `
    : '';

  return `
        <div class="SideBarSearchFilters-container" id="divAllAppliedFilters">
            <div class="SideBarSearchFilters-container-title-wrapper">
                ${filters.length} ${labelTitle}
                <img width="20" height="20" src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/arrow-toggle-up.svg" />
            </div>
            <div id="divSearchFilterAllAppliedFiltersContent">
                <div class="basicTable SideBarSearchFilters-table">
                    ${rowsHtml}
                </div>
                ${toggleHtml}
            </div>
        </div>
    `;
}

export async function attachEventListenersMainSearchPageFilter(
  lang,
  layoutType,
  handleFiltersChangedSharedWithParent
) {
  try {
    //  alert("attachEventListenersMainSearchPageFilter called!");

    //// ✅ Only fetch translations once
    //const [lblShowMore, lblShowLess, lblAppliedFilter, lblAppliedFilters] = await Promise.all([
    //    getTextTranslationByKey("keyShowMore", lang),
    //    getTextTranslationByKey("keyShowLess", lang),
    //    getTextTranslationByKey("keyAppliedFilter", lang),
    //    getTextTranslationByKey("keyAppliedFilters", lang)
    //]);

    const {
      keyShowMore: lblShowMore,
      keyShowLess: lblShowLess,
      keyAppliedFilter: lblAppliedFilter,
      keyAppliedFilters: lblAppliedFilters,
    } = _tempTextTranslator;

    console.log('✅ attachEventListenersMainSearchPageFilter called!');

    ////////////////////////////////////

    const filtersOnlyResultAPIResponse = await fetchDataSearchPageWithFiltersGetFiltersOnly(lang);

    await processCategories(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.departmentsForFilter
    );
    await processSubcategories(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.categoriesForFilter
    );
    await processProducts(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.productsForFilter
    );
    await processSupplierTypes(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.supplierTypesForFilter
    );
    await processSellerLevels(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.sellerLevelsForFilter
    );
    await processBuyTypes(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.buyTypesForFilter
    );
    await processUnitOfMeasures(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.unitOfMeasuresForFilter
    );
    await processCustomisationTypes(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.customisationTypesForFilter
    );
    await processAllRealSpecsAndSpecOptions(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.allRealSpecsAndSpecOptionsForFilter
    );
    await processCountryOfOrigins(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.countryOfOriginsForFilter
    );
    await processCountryOfSellers(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.countryOfSellersForFilter
    );
    await processShippedFromCountries(
      lang,
      filtersOnlyResultAPIResponse.filtersForAllResultListings.shippedFromCountriesForFilter
    );

    const wholeSideBarContent = document.getElementById('wholeSideBarContent');

    if (!wholeSideBarContent) {
      console.warn('⚠️ Could not find sidebar container to update.');
    } else {
      const newSideBarHTML = await buildComponentMainSearchPageFilter(layoutType);

      // Fade out
      wholeSideBarContent.classList.add('fade-out');

      // Wait for fade-out to complete, then update and fade-in
      setTimeout(async () => {
        wholeSideBarContent.innerHTML = newSideBarHTML;

        // Reattach all listeners again
        setupToggleForEachSidebarFilterSection(); // 👈 attach collapsible handlers

        await setupListnersForAllFilterCheckboxes(
          lang,
          layoutType,
          handleFiltersChangedSharedWithParent,
          lblShowMore,
          lblShowLess,
          lblAppliedFilter,
          lblAppliedFilters
        );

        setupShowMoreToggleCheckboxListeners(lblShowMore, lblShowLess); // 👈 re-attach after re-render

        await setupClearFiltersBySectionListeners(
          lang,
          layoutType,
          handleFiltersChangedSharedWithParent,
          lblShowMore,
          lblShowLess,
          lblAppliedFilter,
          lblAppliedFilters
        );
        await setupClearFiltersBySectionPriceOnlyListeners(
          lang,
          layoutType,
          handleFiltersChangedSharedWithParent,
          lblShowMore,
          lblShowLess,
          lblAppliedFilter,
          lblAppliedFilters
        );

        await setupClearFiltersBySectionMOQOnlyListeners(
          lang,
          layoutType,
          handleFiltersChangedSharedWithParent,
          lblShowMore,
          lblShowLess,
          lblAppliedFilter,
          lblAppliedFilters
        );

        //  await setupAllAppliedFilterWithSharedDebounce(lang, searchRequestModel, layoutType, handleFiltersChangedSharedWithParent, lblShowMore, lblShowLess);

        await setupRemoveAppliedFiltersOnRemoveIconsListeners(
          lang,
          layoutType,
          handleFiltersChangedSharedWithParent,
          lblShowMore,
          lblShowLess,
          lblAppliedFilter,
          lblAppliedFilters
        );

        setupToggleForTopAllAppliedFilterSection();
        setupShowMoreToggleTopAllAppliedCheckboxListeners(lblShowMore, lblShowLess);

        await setupListnerForTopAllAppliedClearAllFilters(
          lang,
          layoutType,
          handleFiltersChangedSharedWithParent,
          lblShowMore,
          lblShowLess,
          lblAppliedFilter,
          lblAppliedFilters
        );

        await setupApplyPriceGoButtonListener(
          lang,
          layoutType,
          handleFiltersChangedSharedWithParent,
          lblShowMore,
          lblShowLess,
          lblAppliedFilter,
          lblAppliedFilters
        );
        await setupApplyMOQGoButtonListener(
          lang,
          layoutType,
          handleFiltersChangedSharedWithParent,
          lblShowMore,
          lblShowLess,
          lblAppliedFilter,
          lblAppliedFilters
        );

        setupMobileViewToggleFilterSidebarListeners();

        // Fade in
        wholeSideBarContent.classList.remove('fade-out');
        wholeSideBarContent.classList.add('fade-in');

        // Optional: Remove the class after animation completes
        setTimeout(() => wholeSideBarContent.classList.remove('fade-in'), 300);
      }, 300);
    }
  } catch (error) {
    console.error('❌ Error attaching event listeners to MainSearchPageFilter:', error);
  }
}

//function maybeUpdateSection(
//    specID,
//    apiList,
//    sectionState,
//    renderSectionFn,
//    lang,
//    layoutType
//) {

//    // 1. map raw API items → your UI‐model
//    const incoming = apiList.map(item => ({
//        SearchResultOptionID: item.searchResultOptionID,
//        SearchResultOptionName: item.searchResultOptionName,
//        SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
//        SearchResultOptionIsChecked: searchPageComponentSharedState
//            .pageSpecificListOfSpecOptionsSelectedFilters
//            .some(x => x.SpecID === specID && x.OptionID === item.searchResultOptionID)
//    }));

//    // 2. simple length or JSON string diff
//    if (
//        incoming.length !== (sectionState.listOfResultsInSection?.length || 0)
//        || JSON.stringify(incoming) !== JSON.stringify(sectionState.listOfResultsInSection)
//    ) {

//        // 3. stash the new data
//        sectionState.listOfResultsInSection = incoming;
//        sectionState.divShowMoreIsVisible = incoming.length > getLimitByTypeFor(specID);
//        sectionState.ShowMoreOrLess = appState.SearchFilters[`ckListAll${specID}`]
//            ? "ShowLess" : "ShowMore";

//        // 4. patch the DOM for just this section
//        const container = document.getElementById(`${getTypesNameFor(specID)}Content`);

//        container.innerHTML = renderSectionFn(
//            /* pass your title, labels, sectionState, types, type, specID */
//        );

//        //// 5. re‐wire _only_ that section’s listeners
//       // setupClearFiltersBySectionListeners(/* for specID only */);
//       // setupListnersForAllFilterCheckboxes(/* for specID only */);
//       // setupShowMoreToggleCheckboxListeners(/* for specID only */);
//    }
//}

function setupToggleForEachSidebarFilterSection() {
  document.querySelectorAll('.SideBarSearchFilters-container-title-wrapper').forEach(wrapper => {
    const onToggleFilterSectionClick = () => {
      const next = wrapper.nextElementSibling;
      const arrowIcon = wrapper.querySelector('img');
      if (next && next.style) {
        const isCollapsed = next.style.display === 'none';
        next.style.display = isCollapsed ? 'block' : 'none';
        if (arrowIcon) {
          arrowIcon.style.transition = 'transform 0.3s ease';
          arrowIcon.style.transform = isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)';
        }
      }
    };

    // Prevent duplicate listener stacking
    wrapper.removeEventListener('click', onToggleFilterSectionClick);
    wrapper.addEventListener('click', onToggleFilterSectionClick);

    // Sync initial state
    const next = wrapper.nextElementSibling;
    const arrowIcon = wrapper.querySelector('img');
    if (next && arrowIcon) {
      arrowIcon.style.transform = next.style.display === 'none' ? 'rotate(0deg)' : 'rotate(180deg)';
    }
  });
}

//export function setupToggleForEachSidebarFilterSection() {
//    document.querySelectorAll('.SideBarSearchFilters-container-title-wrapper').forEach(wrapper => {
//        // replace with a clone to clear any old listeners
//        const clone = wrapper.cloneNode(true);
//        wrapper.parentNode.replaceChild(clone, wrapper);

//        // attach the click handler via the registry
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, 'click', () => {
//            const next = clone.nextElementSibling;
//            const arrowIcon = clone.querySelector('img');
//            if (next && next.style) {
//                const isCollapsed = next.style.display === 'none';
//                next.style.display = isCollapsed ? 'block' : 'none';
//                if (arrowIcon) {
//                    arrowIcon.style.transition = 'transform 0.3s ease';
//                    arrowIcon.style.transform = isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)';
//                }
//            }
//        });

//        // set the initial rotation to match the current collapsed state
//        const next = clone.nextElementSibling;
//        const arrowIcon = clone.querySelector('img');
//        if (next && arrowIcon) {
//            arrowIcon.style.transform = next.style.display === 'none'
//                ? 'rotate(0deg)'
//                : 'rotate(180deg)';
//        }
//    });
//}

function setupToggleForTopAllAppliedFilterSection() {
  const container = document.getElementById('divAllAppliedFilters-content-holder');
  if (!container) return;

  const wrapper = container.querySelector('.SideBarSearchFilters-container-title-wrapper');
  if (!wrapper) return;

  const onToggleAppliedFilterClick = () => {
    const next = wrapper.nextElementSibling;
    const arrowIcon = wrapper.querySelector('img');
    if (next && next.style) {
      const isCollapsed = next.style.display === 'none';
      next.style.display = isCollapsed ? 'block' : 'none';
      if (arrowIcon) {
        arrowIcon.style.transition = 'transform 0.3s ease';
        arrowIcon.style.transform = isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)';
      }
    }
  };

  // Prevent duplicate listener stacking
  wrapper.removeEventListener('click', onToggleAppliedFilterClick);
  wrapper.addEventListener('click', onToggleAppliedFilterClick);

  // Sync initial icon rotation
  const next = wrapper.nextElementSibling;
  const arrowIcon = wrapper.querySelector('img');
  if (arrowIcon) {
    arrowIcon.style.transform =
      next && next.style.display === 'none' ? 'rotate(0deg)' : 'rotate(180deg)';
  }
}

//export function setupToggleForTopAllAppliedFilterSection() {
//    const container = document.getElementById("divAllAppliedFilters-content-holder");
//    if (!container) return;

//    const wrapper = container.querySelector(".SideBarSearchFilters-container-title-wrapper");
//    if (!wrapper) return;

//    // Replace with a clone to clear old listeners
//    const clone = wrapper.cloneNode(true);
//    wrapper.parentNode.replaceChild(clone, wrapper);

//    // Attach via the registry
//    addListenerViaCurrentlyAttachedListenersRegistry(clone, 'click', () => {
//        const next = clone.nextElementSibling;
//        const arrowIcon = clone.querySelector('img');
//        if (next && next.style) {
//            const isCollapsed = next.style.display === 'none';
//            next.style.display = isCollapsed ? 'block' : 'none';
//            if (arrowIcon) {
//                arrowIcon.style.transition = 'transform 0.3s ease';
//                arrowIcon.style.transform = isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)';
//            }
//        }
//    });

//    // Set initial icon rotation
//    const arrowIcon = clone.querySelector('img');
//    if (arrowIcon) {
//        // assuming the next sibling is the content container
//        const next = clone.nextElementSibling;
//        arrowIcon.style.transform = next && next.style.display === 'none'
//            ? 'rotate(0deg)'
//            : 'rotate(180deg)';
//    }
//}

function setupShowMoreToggleTopAllAppliedCheckboxListeners(lblShowMore, lblShowLess) {
  const checkbox = document.getElementById('ckListAllAppliedFilters');
  if (!checkbox) return;

  const onCheckboxChange = () => {
    const newValue = checkbox.checked;
    setNestedAppStateValueByKey('SearchFilters', 'ckListAllAppliedFilters', newValue);

    const rows = document.querySelectorAll(`.filter-applied-row`);
    const limit = getLimitByType('AppliedFilters');
    rows.forEach((row, index) => {
      row.style.display = newValue || index < limit ? 'table-row' : 'none';
    });

    const label = document.querySelector(`label[for="ckListAllAppliedFilters"]`);
    if (label) {
      label.textContent = newValue ? lblShowLess : lblShowMore;
    }
  };

  // Prevent duplicate listener stacking
  checkbox.removeEventListener('change', onCheckboxChange);
  checkbox.addEventListener('change', onCheckboxChange);
}

//export function setupShowMoreToggleTopAllAppliedCheckboxListeners(lblShowMore, lblShowLess) {
//    const original = document.getElementById("ckListAllAppliedFilters");
//    if (!original) return;

//    // replace with a clone to clear any old handlers
//    const clone = original.cloneNode(true);
//    original.parentNode.replaceChild(clone, original);

//    addListenerViaCurrentlyAttachedListenersRegistry(clone, "change", () => {
//        const newValue = clone.checked;
//        // Update nested app state
//        setNestedAppStateValueByKey("SearchFilters", "ckListAllAppliedFilters", newValue);

//        // Toggle visibility of applied filter rows
//        const rows = document.querySelectorAll(`.filter-applied-row`);
//        const limit = getLimitByType("AppliedFilters");
//        rows.forEach((row, index) => {
//            row.style.display = newValue || index < limit ? "table-row" : "none";
//        });

//        // Update the toggle label without re-fetching translations
//        const label = document.querySelector(`label[for="ckListAllAppliedFilters"]`);
//        if (label) {
//            label.textContent = newValue ? lblShowLess : lblShowMore;
//        }
//    });
//}

async function setupListnerForTopAllAppliedClearAllFilters(
  lang,
  layoutType,
  handleFiltersChangedSharedWithParent,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  const btn = document.getElementById('btnClearAllFilters');
  if (!btn) return;

  const onClearAllFiltersClick = async () => {
    console.log('🧹 Clear All Filters clicked!');

    const container = document.getElementById('divOtherAppliedFilters-content-holder');
    if (container) {
      searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.forEach(
        filter => {
          const cb = container.querySelector(
            `input[type="checkbox"][data-spec-id="${filter.SpecID}"][data-option-id="${filter.OptionID}"]`
          );
          if (cb) cb.checked = false;
        }
      );
    }

    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.splice(0);
    setAppStateValueByKey('ListOfSpecOptionsSelectedFilters', []);

    document.querySelectorAll('.ClearFilterDiv').forEach(div => {
      div.style.display = 'none';
    });

    await rebuildAndReplaceAllAppliedFiltersSection(
      lang,
      layoutType,
      handleFiltersChangedSharedWithParent,
      lblShowMore,
      lblShowLess,
      lblAppliedFilter,
      lblAppliedFilters
    );
  };

  // Safely reattach without stacking
  btn.removeEventListener('click', onClearAllFiltersClick);
  btn.addEventListener('click', onClearAllFiltersClick);
}

//export async function setupListnerForTopAllAppliedClearAllFilters(
//    lang,
//    layoutType,
//    handleFiltersChangedSharedWithParent,
//    lblShowMore,
//    lblShowLess,
//    lblAppliedFilter,
//    lblAppliedFilters
//) {
//    const btn = document.getElementById("btnClearAllFilters");
//    if (!btn) return;

//    // replace with clone to remove old handlers
//    const clone = btn.cloneNode(true);
//    btn.parentNode.replaceChild(clone, btn);

//    addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//        console.log("🧹 Clear All Filters clicked!");

//        // uncheck all filter checkboxes
//        const container = document.getElementById("divOtherAppliedFilters-content-holder");
//        if (container) {
//            searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.forEach(filter => {
//                const cb = container.querySelector(
//                    `input[type="checkbox"][data-spec-id="${filter.SpecID}"][data-option-id="${filter.OptionID}"]`
//                );
//                if (cb) cb.checked = false;
//            });
//        }

//        // clear selected filters
//        searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.splice(0);
//        setAppStateValueByKey("ListOfSpecOptionsSelectedFilters", []);

//        // hide all per‑section clear buttons
//        document.querySelectorAll(".ClearFilterDiv").forEach(div => {
//            div.style.display = "none";
//        });

//        // rebuild the “Applied Filters” UI
//        await rebuildAndReplaceAllAppliedFiltersSection(
//            lang,
//            layoutType,
//            handleFiltersChangedSharedWithParent,
//            lblShowMore,
//            lblShowLess,
//            lblAppliedFilter,
//            lblAppliedFilters
//        );
//    });
//}

export async function setupListnersForAllFilterCheckboxes(
  lang,
  layoutType,
  handleFiltersChangedSharedWithParent,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  const checkboxes = document.querySelectorAll(
    ".SideBarSearchFilters-table input[type='checkbox']"
  );

  checkboxes.forEach(checkbox => {
    const onCheckboxChange = async event => {
      const el = event.target;
      const specID = el.dataset.specId;
      const specName = el.dataset.specName;
      const optionID = el.dataset.optionId;
      const optionName = el.dataset.optionName;
      const labelPrefix = el.dataset.labelPrefix;

      handleFilterCheckboxToggle({
        specID,
        specName,
        optionID,
        optionName,
        labelPrefix,
      });

      await rebuildAndReplaceAllAppliedFiltersSection(
        lang,
        layoutType,
        handleFiltersChangedSharedWithParent,
        lblShowMore,
        lblShowLess,
        lblAppliedFilter,
        lblAppliedFilters
      );

      startSidebarPulse();
    };

    checkbox.removeEventListener('change', onCheckboxChange);
    checkbox.addEventListener('change', onCheckboxChange);
  });
}

//export async function setupListnersForAllFilterCheckboxes(
//    lang,
//    layoutType,
//    handleFiltersChangedSharedWithParent,
//    lblShowMore,
//    lblShowLess,
//    lblAppliedFilter,
//    lblAppliedFilters
//) {
//    const checkboxes = document.querySelectorAll(
//        ".SideBarSearchFilters-table input[type='checkbox']"
//    );

//    checkboxes.forEach((checkbox) => {
//        // remove old listeners
//        const clone = checkbox.cloneNode(true);
//        checkbox.parentNode.replaceChild(clone, checkbox);

//        // register new listener
//        addListenerViaCurrentlyAttachedListenersRegistry(
//            clone,
//            "change",
//            async (event) => {
//                const el = event.target;
//                const specID = el.dataset.specId;
//                const specName = el.dataset.specName;
//                const optionID = el.dataset.optionId;
//                const optionName = el.dataset.optionName;
//                const labelPrefix = el.dataset.labelPrefix;

//                handleFilterCheckboxToggle({
//                    specID,
//                    specName,
//                    optionID,
//                    optionName,
//                    labelPrefix,
//                });

//                await rebuildAndReplaceAllAppliedFiltersSection(
//                    lang,
//                    layoutType,
//                    handleFiltersChangedSharedWithParent,
//                    lblShowMore,
//                    lblShowLess,
//                    lblAppliedFilter,
//                    lblAppliedFilters
//                );

//                startSidebarPulse();
//            }
//        );
//    });
//}

async function processDebounceAndNotifyParentToRefreshSearchListingsInMainArea(
  lang,
  layoutType,
  handleFiltersChangedSharedWithParent
) {
  const loader = document.getElementsByClassName('search-filter-debounce-loader-class')[0];
  if (loader) loader.style.display = 'block';

  debounceShared(async () => {
    // hide the loader
    if (loader) loader.style.display = 'none';

    //  alert("debounce area");

    //  alert(JSON.stringify(pageSpecificListOfSpecOptionsSelectedFilters));

    await handleFiltersChangedSharedWithParent(lang, layoutType);
  }, 2000);
}

async function setupRemoveAppliedFiltersOnRemoveIconsListeners(
  lang,
  layoutType,
  handleFiltersChangedSharedWithParent,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  const container = document.getElementById('divAllAppliedFilters');
  if (!container) return;

  const removeIcons = container.querySelectorAll('.filter-remove-icon');
  removeIcons.forEach(icon => {
    const onRemoveIconClick = async () => {
      const specID = icon.dataset.specId;
      const specName = icon.dataset.specName;
      const optionID = icon.dataset.optionId;

      const idx = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.findIndex(
        x => x.SpecID === specID && x.OptionID === optionID
      );
      if (idx !== -1) {
        searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.splice(idx, 1);
      }

      setAppStateValueByKey(
        'ListOfSpecOptionsSelectedFilters',
        searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters
      );

      const otherContainer = document.getElementById('divOtherAppliedFilters-content-holder');
      const checkbox = otherContainer?.querySelector(
        `input[type="checkbox"][data-spec-id="${specID}"][data-option-id="${optionID}"]`
      );
      if (checkbox) checkbox.checked = false;

      const sectionBtn = document.getElementById(`divBtnClearFilterBy${specName}`);
      if (sectionBtn) {
        const remaining = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.filter(
          x => x.SpecID === specID
        ).length;
        sectionBtn.style.display = remaining > 0 ? 'block' : 'none';
      }

      await rebuildAndReplaceAllAppliedFiltersSection(
        lang,
        layoutType,
        handleFiltersChangedSharedWithParent,
        lblShowMore,
        lblShowLess,
        lblAppliedFilter,
        lblAppliedFilters
      );
    };

    icon.removeEventListener('click', onRemoveIconClick);
    icon.addEventListener('click', onRemoveIconClick);
  });
}

//export async function setupRemoveAppliedFiltersOnRemoveIconsListeners(
//    lang,
//    layoutType,
//    handleFiltersChangedSharedWithParent,
//    lblShowMore,
//    lblShowLess,
//    lblAppliedFilter,
//    lblAppliedFilters
//) {
//    const container = document.getElementById("divAllAppliedFilters");
//    if (!container) return;

//    const removeIcons = container.querySelectorAll(".filter-remove-icon");
//    removeIcons.forEach((icon) => {
//        // clone to strip any previous handlers
//        const clone = icon.cloneNode(true);
//        icon.parentNode.replaceChild(clone, icon);

//        // register new listener
//        addListenerViaCurrentlyAttachedListenersRegistry(
//            clone,
//            "click",
//            async () => {
//                const specID = clone.dataset.specId;
//                const specName = clone.dataset.specName;
//                const optionID = clone.dataset.optionId;

//                // remove from shared state
//                const idx = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.findIndex(
//                    (x) => x.SpecID === specID && x.OptionID === optionID
//                );
//                if (idx !== -1) {
//                    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.splice(idx, 1);
//                }

//                setAppStateValueByKey(
//                    "ListOfSpecOptionsSelectedFilters",
//                    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters
//                );

//                // uncheck the corresponding checkbox
//                const otherContainer = document.getElementById("divOtherAppliedFilters-content-holder");
//                const checkbox = otherContainer?.querySelector(
//                    `input[type="checkbox"][data-spec-id="${specID}"][data-option-id="${optionID}"]`
//                );
//                if (checkbox) checkbox.checked = false;

//                // hide or show section‑clear button
//                const sectionBtn = document.getElementById(`divBtnClearFilterBy${specName}`);
//                if (sectionBtn) {
//                    const remaining = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.filter(
//                        (x) => x.SpecID === specID
//                    ).length;
//                    sectionBtn.style.display = remaining > 0 ? "block" : "none";
//                }

//                // rebuild applied‑filters UI
//                await rebuildAndReplaceAllAppliedFiltersSection(
//                    lang,
//                    layoutType,
//                    handleFiltersChangedSharedWithParent,
//                    lblShowMore,
//                    lblShowLess,
//                    lblAppliedFilter,
//                    lblAppliedFilters
//                );
//            }
//        );
//    });
//}

async function setupApplyPriceGoButtonListener(
  lang,
  layoutType,
  handleFiltersChangedSharedWithParent,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  const btn = document.getElementById('btnApplyPriceFilter');
  if (!btn) return;

  const onApplyPriceClick = async () => {
    let min = cleanPrice(document.getElementById('txtMinPrice').value);
    let max = cleanPrice(document.getElementById('txtMaxPrice').value);

    if (min > 0 && max > 0 && min > max) {
      min = max;
      document.getElementById('txtMinPrice').value = min.toString();
    }

    upsertIntoFilterList('MinPriceID', 'MinPriceName', min, `Min Price: $${min.toFixed(2)}`);
    upsertIntoFilterList('MaxPriceID', 'MaxPriceName', max, `Max Price: $${max.toFixed(2)}`);

    const clearDiv = document.getElementById('divClearFilterByPrice');
    if (clearDiv) {
      clearDiv.style.display = min > 0 || max > 0 ? 'block' : 'none';
    }

    alert(`min : ${min} : max : ${max}`);

    await rebuildAndReplaceAllAppliedFiltersSection(
      lang,
      layoutType,
      handleFiltersChangedSharedWithParent,
      lblShowMore,
      lblShowLess,
      lblAppliedFilter,
      lblAppliedFilters
    );
  };

  btn.removeEventListener('click', onApplyPriceClick);
  btn.addEventListener('click', onApplyPriceClick);
}

//async function setupApplyPriceGoButtonListener(lang,
//    layoutType,
//    handleFiltersChangedSharedWithParent,
//    lblShowMore,
//    lblShowLess,
//    lblAppliedFilter,
//    lblAppliedFilters) {

//    const btn = document.getElementById("btnApplyPriceFilter");
//    if (!btn) return;

//    // replace with clone to remove old handlers
//    const clone = btn.cloneNode(true);
//    btn.parentNode.replaceChild(clone, btn);

//    addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//   // addListenerViaCurrentlyAttachedListenersRegistry(
//      //  document.getElementById("btnApplyPriceFilter"),
//       // "click",
//       // async () => {
//          //  const min = document.getElementById("txtMinPrice").value.trim();
//           // const max = document.getElementById("txtMaxPrice").value.trim();

//            // 1) read & clean
//            let min = cleanPrice(document.getElementById("txtMinPrice").value);
//            let max = cleanPrice(document.getElementById("txtMaxPrice").value);

//          //  alert(`min : ${min} : max : ${max}`);

//            // 2) if both >0 and min>max, clamp
//            if (min > 0 && max > 0 && min > max) {
//                min = max;
//                document.getElementById("txtMinPrice").value = min.toString();
//            }

//            // 3) upsert both filters
//            upsertIntoFilterList("MinPriceID", "MinPriceName",  min, `Min Price: $${min.toFixed(2)}` );
//            upsertIntoFilterList("MaxPriceID", "MaxPriceName",   max, `Max Price: $${max.toFixed(2)}` );

//            // 4) show/hide the “clear” button wrapper
//            const clearDiv = document.getElementById("divClearFilterByPrice");
//            clearDiv.style.display = (min > 0 || max > 0) ? "block" : "none";

//            alert(`min : ${min} : max : ${max}`);

//            // rebuild applied‑filters UI
//            await rebuildAndReplaceAllAppliedFiltersSection(
//                lang,
//                layoutType,
//                handleFiltersChangedSharedWithParent,
//                lblShowMore,
//                lblShowLess,
//                lblAppliedFilter,
//                lblAppliedFilters
//            );

//            // show or hide clear button
//           // document.getElementById("divClearFilterByPrice").style.display = (min || max) ? "block" : "none";

//            // re-run the search
//            //await handleFiltersChangedSharedWithParent(/*lang, layoutType*/);

//        }
//    );

//}

async function setupApplyMOQGoButtonListener(
  lang,
  layoutType,
  handleFiltersChangedSharedWithParent,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  const btn = document.getElementById('btnApplyMOQFilter');
  if (!btn) return;

  const onApplyMOQClick = async () => {
    let val = document.getElementById('txtMinMOQ').value.trim();
    const min = parseFloat(val) > 0 ? parseFloat(val) : 0;

    upsertIntoFilterList('MinMOQID', 'MinMOQName', min, `Min MOQ: $${min.toFixed(2)}`);

    const clearDiv = document.getElementById('divClearFilterByMOQ');
    if (clearDiv) {
      clearDiv.style.display = min > 0 ? 'block' : 'none';
    }

    alert(`min : ${min}`);

    await rebuildAndReplaceAllAppliedFiltersSection(
      lang,
      layoutType,
      handleFiltersChangedSharedWithParent,
      lblShowMore,
      lblShowLess,
      lblAppliedFilter,
      lblAppliedFilters
    );
  };

  btn.removeEventListener('click', onApplyMOQClick);
  btn.addEventListener('click', onApplyMOQClick);
}

//async function setupApplyMOQGoButtonListener(lang,
//    layoutType,
//    handleFiltersChangedSharedWithParent,
//    lblShowMore,
//    lblShowLess,
//    lblAppliedFilter,
//    lblAppliedFilters) {

//    const btn = document.getElementById("btnApplyMOQFilter");
//    if (!btn) return;

//    // replace with clone to remove old handlers
//    const clone = btn.cloneNode(true);
//    btn.parentNode.replaceChild(clone, btn);

//    addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//        // 1) read & clean

//        let val = document.getElementById("txtMinMOQ").value.trim();

//        const min = parseFloat(val) > 0 ? parseFloat(val) : 0;

//        // 3) upsert both filters
//        upsertIntoFilterList("MinMOQID", "MinMOQName", min, `Min MOQ: $${min.toFixed(2)}`);
//       // upsertMOQFilter("MaxMOQID", "MaxMOQName", max, `Max MOQ: $${max.toFixed(2)}`);

//        // 4) show/hide the “clear” button wrapper
//        const clearDiv = document.getElementById("divClearFilterByMOQ");
//        clearDiv.style.display = (min > 0) ? "block" : "none";

//        alert(`min : ${min}`);

//        // rebuild applied‑filters UI
//        await rebuildAndReplaceAllAppliedFiltersSection(
//            lang,
//            layoutType,
//            handleFiltersChangedSharedWithParent,
//            lblShowMore,
//            lblShowLess,
//            lblAppliedFilter,
//            lblAppliedFilters
//        );

//    }
//    );

//}

function upsertIntoFilterList(specID, specName, value, label) {
  const arr = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters;
  const existing = arr.find(x => x.SpecID === specID);

  if (value > 0) {
    if (existing) {
      existing.OptionID = value.toString();
      existing.OptionName = label;
    } else {
      arr.push({
        SpecID: specID,
        SpecName: specName,
        OptionID: value.toString(),
        OptionName: label,
      });
    }
  } else {
    // remove if present
    if (existing) {
      arr.splice(arr.indexOf(existing), 1);
    }
  }

  // sync back to appState
  setAppStateValueByKey('ListOfSpecOptionsSelectedFilters', arr);
}

function cleanPrice(str) {
  const n = parseFloat(str);
  if (isNaN(n)) return 0;
  // exactly like Math.Round(..., 2, MidpointRounding.AwayFromZero)
  return Math.round(n * 100) / 100;
}

function handleFilterCheckboxToggle({ specID, specName, optionID, optionName, labelPrefix }) {
  // alert(`specID : ${specID} : specName : ${specName} : optionID : ${optionID} : optionName : ${optionName} : labelPrefix : ${labelPrefix}`);

  const existing = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.find(
    x => x.SpecID === specID && x.OptionID === optionID
  );

  let labelPrefixTranslated = document.getElementById(`lblSectionTitleIDFor${labelPrefix}`);

  let labelPrefixTranslatedText = labelPrefix;
  if (labelPrefixTranslated) {
    labelPrefixTranslatedText = labelPrefixTranslated.innerText;
  }

  if (!existing) {
    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.push({
      SpecID: specID,
      SpecName: specName,
      OptionID: optionID,
      OptionName: `${labelPrefixTranslatedText}: ${optionName}`,
    });
  } else {
    //pageSpecificListOfSpecOptionsSelectedFilters =
    //    pageSpecificListOfSpecOptionsSelectedFilters.filter(
    //        x => !(x.SpecID === specID && x.OptionID === optionID)
    //    );

    // find and remove the one element
    //fix for : you’re rebinding the parameter instead of mutating the shared array
    const idx = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.findIndex(
      x => x.SpecID === specID && x.OptionID === optionID
    );
    if (idx > -1) {
      searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.splice(idx, 1);
    }
  }

  //update state
  setAppStateValueByKey(
    'ListOfSpecOptionsSelectedFilters',
    searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters
  );

  // alert(`specName : ${specName} : labelPrefix : ${labelPrefix}  : labelPrefixTranslatedText : ${labelPrefixTranslatedText} : lblSectionTitleIDFor${specName}`);

  //update the clear button for section
  const divBtnClearFilterBy = document.getElementById(`divBtnClearFilterBy${specName}`);

  // alert(`vvv divBtnClearFilterBy${specName}`);

  if (divBtnClearFilterBy) {
    //get count of filters in the section
    const countOfFiltersInSection = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.filter(
      x => x.SpecID === specID
    ).length;

    if (countOfFiltersInSection > 0) {
      divBtnClearFilterBy.style.display = 'block';
    } else {
      divBtnClearFilterBy.style.display = 'none';
    }
  }
}

async function setupShowMoreToggleCheckboxListeners(lblShowMore, lblShowLess) {
  const toggles = document.querySelectorAll(
    '.SideBarSearchFilters-showMore-wrapper input[type="checkbox"]'
  );

  toggles.forEach(toggle => {
    const onToggleChange = () => {
      const id = toggle.id.toString();
      const type = id.replace('ckListAll', '');
      const newValue = toggle.checked;

      setNestedAppStateValueByKey('SearchFilters', id, newValue);

      const rows = document.querySelectorAll(`.filter-row-${type}`);
      const limit = getLimitByType(type);

      rows.forEach((row, index) => {
        row.style.display = newValue || index < limit ? 'table-row' : 'none';
      });

      const label = document.querySelector(`label[for="${id}"]`);
      if (label) {
        label.textContent = newValue ? lblShowLess : lblShowMore;
      }
    };

    toggle.removeEventListener('change', onToggleChange);
    toggle.addEventListener('change', onToggleChange);
  });
}

//export async function setupShowMoreToggleCheckboxListeners(lblShowMore, lblShowLess) {
//    const toggles = document.querySelectorAll('.SideBarSearchFilters-showMore-wrapper input[type="checkbox"]');
//    toggles.forEach(toggle => {
//        const handler = () => {
//            const id = toggle.id.toString();
//            const type = id.replace('ckListAll', '');
//            const newValue = toggle.checked;
//            setNestedAppStateValueByKey("SearchFilters", id, newValue);

//                        // Toggle visibility without full re-render
//                        const rows = document.querySelectorAll(`.filter-row-${type}`);
//                        const limit = getLimitByType(type);

//                        rows.forEach((row, index) => {
//                            if (newValue || index < limit) {
//                                row.style.display = "table-row";
//                            } else {
//                                row.style.display = "none";
//                            }
//                        });

//                        // ✅ Update label text without calling translation again

//            const label = document.querySelector(`label[for="${id}"]`);
//            if (label) label.textContent = newValue ? lblShowLess : lblShowMore;
//        };

//        // REGISTER instead of raw addEventListener
//        addListenerViaCurrentlyAttachedListenersRegistry(toggle, 'change', handler);
//    });
//}

async function setupClearFiltersBySectionListeners(
  lang,
  layoutType,
  handleFiltersChanged,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  document.querySelectorAll('.ClearFilterDiv').forEach(button => {
    const specID = button.dataset.specId;
    const specName = button.dataset.specName;

    const onClearSectionClick = async () => {
      const arr = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters;
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].SpecID === specID) arr.splice(i, 1);
      }

      setAppStateValueByKey('ListOfSpecOptionsSelectedFilters', arr);

      document
        .querySelectorAll(`input[type="checkbox"][data-spec-id="${specID}"]`)
        .forEach(cb => (cb.checked = false));

      const clearDiv = document.getElementById(`divBtnClearFilterBy${specName}`);
      if (clearDiv) clearDiv.style.display = 'none';

      await rebuildAndReplaceAllAppliedFiltersSection(
        lang,
        layoutType,
        handleFiltersChanged,
        lblShowMore,
        lblShowLess,
        lblAppliedFilter,
        lblAppliedFilters
      );
    };

    button.removeEventListener('click', onClearSectionClick);
    button.addEventListener('click', onClearSectionClick);
  });
}

//export async function setupClearFiltersBySectionListeners(
//    lang, layoutType, handleFiltersChanged, lblShowMore, lblShowLess, lblAppliedFilter, lblAppliedFilters
//) {
//    document.querySelectorAll('.ClearFilterDiv').forEach(button => {
//        const specID = button.dataset.specId;
//        const specName = button.dataset.specName;

//        // use addListener instead of button.addEventListener(...)
//        addListenerViaCurrentlyAttachedListenersRegistry(button, 'click', async () => {
//            // remove matching filters in‑place
//            const arr = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters;
//            for (let i = arr.length - 1; i >= 0; i--) {
//                if (arr[i].SpecID === specID) arr.splice(i, 1);
//            }

//            // sync to global appState
//            setAppStateValueByKey("ListOfSpecOptionsSelectedFilters", arr);

//            // untick their checkboxes
//            document
//                .querySelectorAll(`input[type="checkbox"][data-spec-id="${specID}"]`)
//                .forEach(cb => cb.checked = false);

//            // hide this section’s “clear” button
//            const clearDiv = document.getElementById(`divBtnClearFilterBy${specName}`);
//            if (clearDiv) clearDiv.style.display = 'none';

//            // rebuild the “Applied Filters” UI
//            await rebuildAndReplaceAllAppliedFiltersSection(
//                lang, layoutType, handleFiltersChanged,
//                lblShowMore, lblShowLess, lblAppliedFilter, lblAppliedFilters
//            );
//        });
//    });
//}

export async function setupClearFiltersBySectionPriceOnlyListeners(
  lang,
  layoutType,
  handleFiltersChanged,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  document.querySelectorAll('.ClearFilterDivMinMaxPriceOnly').forEach(button => {
    const onClearPriceFiltersClick = async () => {
      const specIDs = ['MaxPriceID', 'MinPriceID'];
      const arr = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters;

      for (let i = arr.length - 1; i >= 0; i--) {
        if (specIDs.includes(arr[i].SpecID)) {
          arr.splice(i, 1);
        }
      }

      const txtMinPrice = document.getElementById('txtMinPrice');
      const txtMaxPrice = document.getElementById('txtMaxPrice');
      if (txtMinPrice) txtMinPrice.value = '';
      if (txtMaxPrice) txtMaxPrice.value = '';

      setAppStateValueByKey('ListOfSpecOptionsSelectedFilters', arr);

      const clearDiv = document.getElementById(`divClearFilterByPrice`);
      if (clearDiv) clearDiv.style.display = 'none';

      await rebuildAndReplaceAllAppliedFiltersSection(
        lang,
        layoutType,
        handleFiltersChanged,
        lblShowMore,
        lblShowLess,
        lblAppliedFilter,
        lblAppliedFilters
      );
    };

    button.removeEventListener('click', onClearPriceFiltersClick);
    button.addEventListener('click', onClearPriceFiltersClick);
  });
}

//export async function setupClearFiltersBySectionPriceOnlyListeners(
//    lang, layoutType, handleFiltersChanged, lblShowMore, lblShowLess, lblAppliedFilter, lblAppliedFilters
//) {
//    document.querySelectorAll('.ClearFilterDivMinMaxPriceOnly').forEach(button => {

//        // use addListener instead of button.addEventListener(...)
//        addListenerViaCurrentlyAttachedListenersRegistry(button, 'click', async () => {
//            //ids to remove, MaxPriceID and MinPriceID
//            const specIDs = ["MaxPriceID", "MinPriceID"];

//            // remove matching filters in‑place
//            const arr = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters;
//            for (let i = arr.length - 1; i >= 0; i--) {
//                if (specIDs.includes(arr[i].SpecID)) {
//                    arr.splice(i, 1);
//                }
//            }

//            // set the min and max price to 0
//            const txtMinPrice = document.getElementById("txtMinPrice");
//            const txtMaxPrice = document.getElementById("txtMaxPrice");

//            if (txtMinPrice) txtMinPrice.value = "";
//            if (txtMaxPrice) txtMaxPrice.value = "";

//            // sync to global appState
//            setAppStateValueByKey("ListOfSpecOptionsSelectedFilters", arr);

//            // hide this section’s “clear” button

//            // 4) show/hide the “clear” button wrapper
//           // const clearDiv = document.getElementById("divClearFilterByPrice");
//           // clearDiv.style.display = (min > 0 || max > 0) ? "block" : "none";

//            const clearDiv = document.getElementById(`divClearFilterByPrice`);
//            if (clearDiv) clearDiv.style.display = 'none';

//            // rebuild the “Applied Filters” UI
//            await rebuildAndReplaceAllAppliedFiltersSection(
//                lang, layoutType, handleFiltersChanged,
//                lblShowMore, lblShowLess, lblAppliedFilter, lblAppliedFilters
//            );
//        });
//    });
//}

export async function setupClearFiltersBySectionMOQOnlyListeners(
  lang,
  layoutType,
  handleFiltersChanged,
  lblShowMore,
  lblShowLess,
  lblAppliedFilter,
  lblAppliedFilters
) {
  document.querySelectorAll('.ClearFilterDivMinMaxMOQOnly').forEach(button => {
    const onClearMOQFiltersClick = async () => {
      const specIDs = ['MaxMOQID', 'MinMOQID'];
      const arr = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters;

      for (let i = arr.length - 1; i >= 0; i--) {
        if (specIDs.includes(arr[i].SpecID)) {
          arr.splice(i, 1);
        }
      }

      const txtMinMOQ = document.getElementById('txtMinMOQ');
      if (txtMinMOQ) txtMinMOQ.value = '';

      setAppStateValueByKey('ListOfSpecOptionsSelectedFilters', arr);

      const clearDiv = document.getElementById(`divClearFilterByMOQ`);
      if (clearDiv) clearDiv.style.display = 'none';

      await rebuildAndReplaceAllAppliedFiltersSection(
        lang,
        layoutType,
        handleFiltersChanged,
        lblShowMore,
        lblShowLess,
        lblAppliedFilter,
        lblAppliedFilters
      );
    };

    button.removeEventListener('click', onClearMOQFiltersClick);
    button.addEventListener('click', onClearMOQFiltersClick);
  });
}

//export async function setupClearFiltersBySectionMOQOnlyListeners(
//    lang, layoutType, handleFiltersChanged, lblShowMore, lblShowLess, lblAppliedFilter, lblAppliedFilters
//) {
//    document.querySelectorAll('.ClearFilterDivMinMaxMOQOnly').forEach(button => {

//        // use addListener instead of button.addEventListener(...)
//        addListenerViaCurrentlyAttachedListenersRegistry(button, 'click', async () => {
//            //ids to remove
//            const specIDs = ["MaxMOQID", "MinMOQID"];

//            // remove matching filters in‑place
//            const arr = searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters;
//            for (let i = arr.length - 1; i >= 0; i--) {
//                if (specIDs.includes(arr[i].SpecID)) {
//                    arr.splice(i, 1);
//                }
//            }

//            // set the min and max moq to 0
//            const txtMinMOQ = document.getElementById("txtMinMOQ");

//            if (txtMinMOQ) txtMinMOQ.value = "";

//            // sync to global appState
//            setAppStateValueByKey("ListOfSpecOptionsSelectedFilters", arr);

//            // hide this section’s “clear” button

//            const clearDiv = document.getElementById(`divClearFilterByMOQ`);
//            if (clearDiv) clearDiv.style.display = 'none';

//            // rebuild the “Applied Filters” UI
//            await rebuildAndReplaceAllAppliedFiltersSection(
//                lang, layoutType, handleFiltersChanged,
//                lblShowMore, lblShowLess, lblAppliedFilter, lblAppliedFilters
//            );
//        });
//    });
//}

async function processCategories(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processCategories called!');

  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }

  // Reset section
  sectionData.categories.listOfResultsInSection = [];

  for (const item of filterDataListResultForSection) {
    sectionData.categories.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'DeptID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }

  // Sort alphabetically by name if counts are equal, else by descending count
  sectionData.categories.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );

  const totalCount = sectionData.categories.listOfResultsInSection.length;
  const limit = limitBeforeShowingMoreCategory;

  sectionData.categories.divShowMoreIsVisible = totalCount > limit;
  sectionData.categories.ShowMoreOrLess = appState.SearchFilters.ckListAllCategories
    ? 'ShowLess'
    : 'ShowMore';
}

async function processSubcategories(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processSubcategories called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }
  // Reset section
  sectionData.subcategories.listOfResultsInSection = [];
  for (const item of filterDataListResultForSection) {
    sectionData.subcategories.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'CatID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }
  // Sort alphabetically by name if counts are equal, else by descending count
  sectionData.subcategories.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );

  const totalCount = sectionData.subcategories.listOfResultsInSection.length;
  const limit = limitBeforeShowingMoreSubcategory;
  sectionData.subcategories.divShowMoreIsVisible = totalCount > limit;
  sectionData.subcategories.ShowMoreOrLess = appState.SearchFilters.ckListAllSubcategories
    ? 'ShowLess'
    : 'ShowMore';
}

async function processProducts(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processProducts called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }
  // Reset section
  sectionData.products.listOfResultsInSection = [];

  for (const item of filterDataListResultForSection) {
    sectionData.products.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'ProductID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }

  // Sort alphabetically by name if counts are equal, else by descending count
  sectionData.products.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );

  const totalCount = sectionData.products.listOfResultsInSection.length;
  const limit = limitBeforeShowingMoreProduct;
  sectionData.products.divShowMoreIsVisible = totalCount > limit;
  sectionData.products.ShowMoreOrLess = appState.SearchFilters.ckListAllProducts
    ? 'ShowLess'
    : 'ShowMore';
}

async function processSupplierTypes(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processSupplierType called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }

  // Reset section
  sectionData.supplierTypes.listOfResultsInSection = [];

  // Map each raw item into your UI model

  for (const item of filterDataListResultForSection) {
    sectionData.supplierTypes.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'SupplierTypeID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }

  //  alert(JSON.stringify(sectionData.supplierTypes.listOfResultsInSection));

  // Sort by descending count, then name
  sectionData.supplierTypes.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );

  // Determine if we need a “Show More / Show Less” toggle
  const totalCount = sectionData.supplierTypes.listOfResultsInSection.length;
  const limit = 3;
  sectionData.supplierTypes.divShowMoreIsVisible = totalCount > limit;
  sectionData.supplierTypes.ShowMoreOrLess = appState.SearchFilters.ckListAllSupplierType
    ? 'ShowLess'
    : 'ShowMore';
}

async function processSellerLevels(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processSellerLevels called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }
  // Reset section
  sectionData.sellerLevels.listOfResultsInSection = [];
  // Map each raw item into your UI model
  for (const item of filterDataListResultForSection) {
    sectionData.sellerLevels.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'SellerLevelID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }
  // Sort by descending count, then name
  sectionData.sellerLevels.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );

  // Determine if we need a “Show More / Show Less” toggle
  const totalCount = sectionData.sellerLevels.listOfResultsInSection.length;
  const limit = 3;
  sectionData.sellerLevels.divShowMoreIsVisible = totalCount > limit;
  sectionData.sellerLevels.ShowMoreOrLess = appState.SearchFilters.ckListAllSellerLevel
    ? 'ShowLess'
    : 'ShowMore';
}

async function processBuyTypes(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processBuyTypes called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }

  // Reset section
  sectionData.buyTypes.listOfResultsInSection = [];
  // Map each raw item into your UI model
  for (const item of filterDataListResultForSection) {
    sectionData.buyTypes.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'BuyTypeID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }
  // Sort by descending count, then name
  sectionData.buyTypes.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );

  // Determine if we need a “Show More / Show Less” toggle
  const totalCount = sectionData.buyTypes.listOfResultsInSection.length;
  const limit = 3;
  sectionData.buyTypes.divShowMoreIsVisible = totalCount > limit;
  sectionData.buyTypes.ShowMoreOrLess = appState.SearchFilters.ckListAllBuyType
    ? 'ShowLess'
    : 'ShowMore';
}

async function processUnitOfMeasures(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processUnitOfMeasures called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }
  // Reset section
  sectionData.unitOfMeasures.listOfResultsInSection = [];
  // Map each raw item into your UI model
  for (const item of filterDataListResultForSection) {
    sectionData.unitOfMeasures.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'UnitOfMeasureID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }
  // Sort by descending count, then name
  sectionData.unitOfMeasures.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );
  // Determine if we need a “Show More / Show Less” toggle
  const totalCount = sectionData.unitOfMeasures.listOfResultsInSection.length;
  const limit = 3;
  sectionData.unitOfMeasures.divShowMoreIsVisible = totalCount > limit;
  sectionData.unitOfMeasures.ShowMoreOrLess = appState.SearchFilters.ckListAllUnitOfMeasure
    ? 'ShowLess'
    : 'ShowMore';
}

async function processCustomisationTypes(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processCustomisationTypes called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }
  // Reset section
  sectionData.customisationTypes.listOfResultsInSection = [];
  // Map each raw item into your UI model
  for (const item of filterDataListResultForSection) {
    sectionData.customisationTypes.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'CustomisationTypeID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }
  // Sort by descending count, then name
  sectionData.customisationTypes.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );
  // Determine if we need a “Show More / Show Less” toggle
  const totalCount = sectionData.customisationTypes.listOfResultsInSection.length;
  const limit = 3;
  sectionData.customisationTypes.divShowMoreIsVisible = totalCount > limit;
  sectionData.customisationTypes.ShowMoreOrLess = appState.SearchFilters.ckListAllCustomisationType
    ? 'ShowLess'
    : 'ShowMore';
}

async function processAllRealSpecsAndSpecOptions(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processAllRealSpecs called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }

  // alert(filterDataListResultForSection);
  //   alert(`processAllRealSpecsAndSpecOptions filterDataListResultForSection : ${JSON.stringify(filterDataListResultForSection)}`);

  // Reset section
  sectionData.allRealSpecsAndSpecOptions = [];

  // first, build your uniqueSpecs (only once)
  const seen = new Set();
  const uniqueSpecs = filterDataListResultForSection
    .filter(item => {
      if (!item.specID || !item.specName || seen.has(item.specID)) return false;
      seen.add(item.specID);
      return true;
    })
    .map(({ specID, specName }) => ({
      specID: String(specID),
      specName: String(specName),
    }))
    .sort((a, b) => a.specName.localeCompare(b.specName));

  // then build one group per spec:
  const groups = uniqueSpecs.map(({ specID, specName }) => {
    // find all the options that belong to this spec
    const optionsForThisSpec = filterDataListResultForSection.filter(
      item => String(item.specID) === specID
    );

    // map into your UI‐model
    const list = optionsForThisSpec.map(opt => ({
      SearchResultOptionID: opt.optionID,
      SearchResultOptionName: opt.optionName,
      SearchResultOptionCount: Math.min(opt.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === specID && x.OptionID === String(opt.optionID)
      ),
    }));

    // sort by count desc, then name asc
    list.sort(
      (a, b) =>
        b.SearchResultOptionCount - a.SearchResultOptionCount ||
        a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
    );

    // decide whether to show “more” toggle
    const divShowMore = list.length > limitBeforeShowingMoreSpecAndOptions;
    const ShowMoreOrLess = appState.SearchFilters[`ckListAll${specID}`] ? 'ShowLess' : 'ShowMore';

    return {
      title: specName,
      data: {
        listOfResultsInSection: list,
        divShowMoreIsVisible: divShowMore,
        ShowMoreOrLess,
      },
      types: `SpecNumbers${specID}`,
      type: `SpecNumber${specID}`,
      specID,
    };
  });

  //// 1. Build a Set of seen IDs as we go…
  //const seen = new Set();
  //const uniqueSpecs = filterDataListResultForSection
  //    // 2. Keep only the first occurrence of each specID with a non‐empty name
  //    .filter(item => {
  //        if (!item.specID || !item.specName) return false;
  //        if (seen.has(item.specID)) return false;
  //        seen.add(item.specID);
  //        return true;
  //    })
  //    // 3. Map down to just the two fields you care about
  //    .map(({ specID, specName }) => ({
  //        specID: String(specID),
  //        specName: String(specName)
  //    }))
  //    // 4. Sort by specName ascending
  //    .sort((a, b) => a.specName.localeCompare(b.specName));

  //alert(`uniqueSpecs : ${JSON.stringify(uniqueSpecs)}`);

  //// build one group object per parent spec
  //const groups = filterDataListResultForSection.map(parent => {

  //    // assume parent.options is the array of child options
  //    const list = (parent.options || []).map(opt => ({
  //        SearchResultOptionID: opt.optionID,
  //        SearchResultOptionName: opt.optionName,
  //        SearchResultOptionCount: Math.min(opt.searchResultOptionCount || 1, 99),
  //        SearchResultOptionIsChecked: searchPageComponentSharedState
  //            .pageSpecificListOfSpecOptionsSelectedFilters
  //            .some(x => x.SpecID === parent.specID.toString() && x.OptionID === opt.optionID.toString())
  //    }));

  //    // sort if you like
  //    list.sort((a, b) =>
  //        b.SearchResultOptionCount - a.SearchResultOptionCount ||
  //        a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  //    );

  //    const divShowMore = list.length > limitBeforeShowingMoreSpecAndOptions;
  //    const showMoreOrLess = appState.SearchFilters[`ckListAll${parent.specID}`] ? "ShowLess" : "ShowMore";

  //    const newChildSectionData = {
  //        listOfResultsInSection: list,
  //        divShowMoreIsVisible: divShowMore,
  //        ShowMoreOrLess: showMoreOrLess
  //    };

  //    return {
  //        title: parent.specName,
  //        data: newChildSectionData,
  //        types: `SpecNumbers${parent.specID}`,
  //        type: `SpecNumber${parent.specID}`,
  //        specID: parent.specID
  //    };
  //});

  //  alert(JSON.stringify(groups));

  // replace the array
  sectionData.allRealSpecsAndSpecOptions = groups;

  //"allRealSpecsAndSpecOptionsForFilter": [
  //    {
  //        "specID": "1",
  //        "specName": "Colour",
  //        "optionID": "1",
  //        "optionName": "Silver",
  //        "specAndOptionCount": 2
  //    },
  //    {
  //        "specID": "1",
  //        "specName": "Colour",
  //        "optionID": "3",
  //        "optionName": "Yellow",
  //        "specAndOptionCount": 3
  //    },

  //// Reset section
  ////sectionData.allRealSpecsAndSpecOptions.listOfResultsInSection = [];

  //let sectionData = {
  //    /* … your existing sections … */
  //    allRealSpecsAndSpecOptions: {
  //        listOfResultsInSection: [],
  //        divShowMoreIsVisible: false,
  //        ShowMoreOrLess: "ShowMore"
  //    }
  //}

  //// allRealSpecsAndSpecOptions in one level higher than the other sections
  //// Map each raw item into your UI model
  //for (const parentItem of filterDataListResultForSection) {

  //    const subSectionData = [];
  //    const typesName = `SpecNumbers` + parentItem.specID;
  //    const typeName = `SpecNumber` + parentItem.specID;

  //    // Map each raw item into your UI model
  //    for (const child of parentItem) {
  //        subSectionData.subListOfResultsInSection.push({
  //            SearchResultOptionID: child.optionID,
  //            SearchResultOptionName: child.optionName,
  //            SearchResultOptionCount: Math.min(child.searchResultOptionCount || 1, 99),
  //            SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
  //                x => x.SpecID === child.specID && x.OptionID === child.searchResultOptionID
  //            )
  //        });
  //    }

  //    sectionData.allRealSpecsAndSpecOptions.listOfResultsInSection.push({
  //        Title: parentItem.specName,
  //        sectionData: subSectionData,
  //        types: typesName,
  //        type: typeName,
  //        SpecID: parentItem.specID,

  //    });
  //}
}

async function processCountryOfOrigins(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processCountryOfOrigins called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }
  // Reset section
  sectionData.countryOfOrigins.listOfResultsInSection = [];
  // Map each raw item into your UI model
  for (const item of filterDataListResultForSection) {
    sectionData.countryOfOrigins.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'CountryOfOriginID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }
  // Sort by descending count, then name
  sectionData.countryOfOrigins.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );
  // Determine if we need a “Show More / Show Less” toggle
  const totalCount = sectionData.countryOfOrigins.listOfResultsInSection.length;
  const limit = 3;
  sectionData.countryOfOrigins.divShowMoreIsVisible = totalCount > limit;
  sectionData.countryOfOrigins.ShowMoreOrLess = appState.SearchFilters.ckListAllCountryOfOrigin
    ? 'ShowLess'
    : 'ShowMore';
}

async function processCountryOfSellers(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processCountryOfSellers called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }
  // Reset section
  sectionData.countryOfSellers.listOfResultsInSection = [];
  // Map each raw item into your UI model
  for (const item of filterDataListResultForSection) {
    sectionData.countryOfSellers.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'CountryOfSellerID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }
  // Sort by descending count, then name
  sectionData.countryOfSellers.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );
  // Determine if we need a “Show More / Show Less” toggle
  const totalCount = sectionData.countryOfSellers.listOfResultsInSection.length;
  const limit = 3;
  sectionData.countryOfSellers.divShowMoreIsVisible = totalCount > limit;
  sectionData.countryOfSellers.ShowMoreOrLess = appState.SearchFilters.ckListAllCountryOfSeller
    ? 'ShowLess'
    : 'ShowMore';
}

async function processShippedFromCountries(lang, filterDataListResultForSection) {
  console.log('✅ MainSearchPageFilter processShippedFromCountries called!');
  if (!Array.isArray(filterDataListResultForSection)) {
    console.warn('⚠️ filterDataListResultForSection is not a valid array.');
    return;
  }
  // Reset section
  sectionData.shippedFromCountries.listOfResultsInSection = [];
  // Map each raw item into your UI model
  for (const item of filterDataListResultForSection) {
    sectionData.shippedFromCountries.listOfResultsInSection.push({
      SearchResultOptionID: item.searchResultOptionID,
      SearchResultOptionName: item.searchResultOptionName,
      SearchResultOptionCount: Math.min(item.searchResultOptionCount || 1, 99),
      SearchResultOptionIsChecked: searchPageComponentSharedState.pageSpecificListOfSpecOptionsSelectedFilters.some(
        x => x.SpecID === 'ShippedFromCountryID' && x.OptionID === item.searchResultOptionID
      ),
    });
  }
  // Sort by descending count, then name
  sectionData.shippedFromCountries.listOfResultsInSection.sort(
    (a, b) =>
      b.SearchResultOptionCount - a.SearchResultOptionCount ||
      a.SearchResultOptionName.localeCompare(b.SearchResultOptionName)
  );
  // Determine if we need a “Show More / Show Less” toggle
  const totalCount = sectionData.shippedFromCountries.listOfResultsInSection.length;
  const limit = 3;
  sectionData.shippedFromCountries.divShowMoreIsVisible = totalCount > limit;
  sectionData.shippedFromCountries.ShowMoreOrLess = appState.SearchFilters
    .ckListAllShippedFromCountry
    ? 'ShowLess'
    : 'ShowMore';
}

export function startSidebarPulse() {
  const sidebarWrapper = document.querySelector('.SideBarSearchFilters-wrapper-container');
  if (sidebarWrapper) {
    sidebarWrapper.classList.add('SideBarSearchFilters-pulse');
  }
}

export function stopSidebarPulse() {
  const sidebarWrapper = document.querySelector('.SideBarSearchFilters-wrapper-container');
  if (sidebarWrapper) {
    sidebarWrapper.classList.remove('SideBarSearchFilters-pulse');
  }
}

async function fetchDataSearchPageWithFiltersGetFiltersOnly(lang) {
  //returns the full reponse

  const emptyApiResponseForSearch = {
    howManyItemsFound: '0',
    howManyItemsFound: '0',
    filtersForAllResultListings: {
      departmentsForFilter: [],
      categoriesForFilter: [],
      productsForFilter: [],
      supplierTypesForFilter: [],
      sellerLevelsForFilter: [],
      buyTypesForFilter: [],
      unitOfMeasuresForFilter: [],
      customisationTypesForFilter: [],
      allRealSpecsAndSpecOptions: [],
      countryOfOriginsForFilter: [],
      countryOfSellersForFilter: [],
      shippedFromCountriesForFilter: [],
    },
    listOfResultListings: [],
  };

  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All listings from pre-built data");
      //const data = await myFetchJsonContentFromBuildData("listing.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[lang]) {
      //    const products = data[lang];
      //    console.log(`✅ Loaded All products for language '${lang}' from pre-built data`);
      //    return products;
      //} else {
      //    console.warn(`⚠️ No All products found for language '${lang}'`);
      //    return [];
      //}
    } else {
      populateSearchRequestModelFromSelectedFilters();

      searchPageComponentSharedState.searchRequestModel.returnType = 'listingsID'; //"paged"

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/SearchCatalogWithFiltersAtSKULevel2024Async`;

      // const apiEndPoint = `https://localhost:7009/api/CatalogDataService/SearchCatalogWithFiltersAtSKULevel2024Async`;

      // const apiEndPoint = `https://localhost:7009/api/CatalogDataService/SearchCatalogWithFiltersAtSKULevel2024FiltersOnlyAsync`;

      const response = await fetch(apiEndPoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(searchPageComponentSharedState.searchRequestModel),
      });

      if (!response.ok) throw new Error('Failed to fetch All listings from server');

      const allListingsAndPagesInfoInfoApiResult = await response.json();

      // console.log(` ${allListingsAndPagesInfoInfoApiResult}`);

      // // Save to localStorage
      // saveToLocalStorage(storageKey, allListings);
      // saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log('🌐 Fetched All listings from the server');
      return allListingsAndPagesInfoInfoApiResult;
    }
  } catch (error) {
    console.error('❌ Error fetching listings:', error);
    return emptyApiResponseForSearch;
  }
}

function toggleFilterContainer() {
  const container = document.querySelector('.SideBarSearchFilters-wrapper-container');
  if (container) container.style.display = container.style.display === 'none' ? 'block' : 'none';
}

function clearAllFilters() {
  document
    .querySelectorAll('.SideBarSearchFilters-table input[type="checkbox"]')
    .forEach(cb => (cb.checked = false));
  console.log('✅ All filters cleared');
}

function getLimitByType(types) {
  switch (types) {
    case 'Categories':
      return limitBeforeShowingMoreCategory;
    case 'Subcategories':
      return limitBeforeShowingMoreSubcategory;
    case 'Products':
      return limitBeforeShowingMoreProduct;
    default:
      return 3;
  }
}

function getLimitByTypeFor(specID) {
  switch (specID) {
    case 'DeptID':
      return limitBeforeShowingMoreCategory;
    case 'CatID':
      return limitBeforeShowingMoreSubcategory;
    case 'ProductID':
      return limitBeforeShowingMoreProduct;
    default:
      return 3;
  }
}
function getTypesNameFor(specID) {
  return {
    DeptID: 'Categories',
    CatID: 'Subcategories',
    ProductID: 'Products',
    SupplierTypeID: 'SupplierTypes',
    SellerLevelID: 'SellerLevels',
    BuyTypeID: 'BuyTypes',
    UnitOfMeasureID: 'UnitOfMeasures',
    CustomisationTypeID: 'CustomisationTypes',
    CountryOfOriginID: 'CountryOfOrigins',
    CountryOfSellerID: 'CountryOfSellers',
    ShippedFromCountryID: 'ShippedFromCountries',
  }[specID];
}

//function getSpecIDByType(types) {
//    switch (types) {
//        case 'Categories': return 'DeptID';
//        case 'Subcategories': return 'CatID';
//        case 'Products': return 'ProductID';
//        default: return '';
//    }
//}

//function setupMobileViewToggleFilterSidebarListeners() {
//    // Show buttons
//    document.querySelectorAll('.js-show-filter-btn').forEach(btn => {
//        const clone = btn.cloneNode(true);
//        btn.parentNode.replaceChild(clone, btn);
//        clone.addEventListener('click', mobileViewShowFilterContainer);
//    });

//    // Hide buttons
//    document.querySelectorAll('.js-hide-filter-btn').forEach(btn => {
//        const clone = btn.cloneNode(true);
//        btn.parentNode.replaceChild(clone, btn);
//        clone.addEventListener('click', mobileViewHideFilterContainer);
//    });
//}

function setupMobileViewToggleFilterSidebarListeners() {
  document.querySelectorAll('.js-show-filter-btn').forEach(btn => {
    btn.removeEventListener('click', mobileViewShowFilterContainer);
    btn.addEventListener('click', mobileViewShowFilterContainer);
  });

  document.querySelectorAll('.js-hide-filter-btn').forEach(btn => {
    btn.removeEventListener('click', mobileViewHideFilterContainer);
    btn.addEventListener('click', mobileViewHideFilterContainer);
  });
}

//export function setupMobileViewToggleFilterSidebarListeners() {
//    // show the mobile filter
//    document.querySelectorAll('.js-show-filter-btn').forEach(btn => {
//        addListenerViaCurrentlyAttachedListenersRegistry(btn, 'click', mobileViewShowFilterContainer);
//    });

//    // hide the mobile filter
//    document.querySelectorAll('.js-hide-filter-btn').forEach(btn => {
//        addListenerViaCurrentlyAttachedListenersRegistry(btn, 'click', mobileViewHideFilterContainer);
//    });
//}

function mobileViewShowFilterContainer() {
  // alert("ToogleShowFilterContainer mobile");

  const sideBar = document.getElementById('wholeSideBarContent');

  if (sideBar) {
    if (sideBar.classList.contains('class-filter-collpased')) {
      sideBar.classList.remove('class-filter-collpased');

      // Prevent the background from scrolling:
      document.body.classList.add('no-scroll-class-filter-collpased');

      //  alert("class-filter-collpased removed");
    } else {
      //  alert("class-filter-collpased no action performed");
    }
  } else {
    //  alert("SideBar not found");
  }
}

function mobileViewHideFilterContainer() {
  // alert("ToogleHideFilterContainer mobile");

  const sideBar = document.getElementById('wholeSideBarContent');

  //class-filter-collpased hides the sidebar

  if (sideBar) {
    if (sideBar && !sideBar.classList.contains('class-filter-collpased')) {
      sideBar.classList.add('class-filter-collpased');
      // alert("class-filter-collpased added");

      // Re‑enable scroll on the background:
      document.body.classList.remove('no-scroll-class-filter-collpased');
    } else {
      //  alert("class-filter-collpased no action performed");
    }
  } else {
    // alert("SideBar not found");
  }
}

//// when this script loads, subscribe to changes in the searchRequestModel // hold on to the returned functio
//// FYI If you ever tear down the filter panel, call unsubscribeFilters();
//const unsubscribeFilters = searchPageComponentSharedState.subscribe((store) => {
//    // e.g. rebuild your filter UI if the model changed
//    attachEventListenersMainSearchPageFilter(
//        store.searchRequestModel.LanguageCode,
//        store.searchRequestModel.LayoutType,
//    /* callback to parent */() => handleFiltersChangedSharedWithParent( /* … */)
//    );
//});
